import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
        token: null,
        lastFetch: null,
        isLoading: true,
    }),
    actions: {
        async register(credentials) {
            try {
                const runtimeConfig = useRuntimeConfig();
                const { data: response } = await useFetch(runtimeConfig.public.backendUrl +  '/api/v2/auth/register', {
                    method: 'POST',
                    body: JSON.stringify(credentials),
                });
                this.token = response.value.token
                localStorage.setItem('token', this.token)
            } catch (error) {
                throw error;
            }
        },

        async login(credentials) {
            try {
                const runtimeConfig = useRuntimeConfig();
                const { data: response } = await useFetch(runtimeConfig.public.backendUrl +  '/api/v2/auth/login', {
                    method: 'POST',
                    body: JSON.stringify(credentials)
                });
                this.token = response.value.token
                localStorage.setItem('token', this.token)
                await this.fetchUserData(response.value.token)
            } catch (error) {
                throw error;
            }
        },

        logout() {
            this.user = null
            this.token = null
            this.lastFetch = null
            localStorage.removeItem('token')
            localStorage.removeItem('user')
            localStorage.removeItem('last_fetch')
        },

        async fetchUserData(token) {
            const runtimeConfig = useRuntimeConfig();
            try {
                const response = await fetch(runtimeConfig.public.backendUrl +  '/api/v2/user', {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Cache-Control': 'no-cache'
                    },
                });

                if (!response.ok) {
                    this.logout()
                    return;
                }

                this.user = await response.json();
                this.lastFetch = Date.now()
                this.isLoading = false
                localStorage.setItem('user', JSON.stringify(this.user))
                localStorage.setItem('last_fetch', this.lastFetch)

            } catch (error) {
            }
        },

        async loadUserFromStorage() {
            const token = localStorage.getItem('token')
            const user = localStorage.getItem('user')
            const lastFetch = localStorage.getItem('last_fetch')
            if (token) {
                this.token = token
            }
            if (user) {
                this.user = JSON.parse(user)

                if (lastFetch) {
                    this.lastFetch = lastFetch
                }

                const tenMinutes = 10 * 60 * 1000; // 10 minutes in milliseconds
                const now = Date.now();

                if (token && user && lastFetch && (now - lastFetch > tenMinutes)) {
                    await this.fetchUserData(token)
                }
            }

            this.isLoading = false
        }
    }
})